import { emulatorScreen, mobileScreen } from "../utils/styleUtils";

const styles = (theme) => ({
  questionContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "start",
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
    },
  },
  questionText: {
    paddingTop: 20,
    textAlign: "left",
    color: "#043e4b",
    fontSize: 22,
    fontWeight: 500,
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      fontSize: 16,
      margin: "10px 0px",
      paddingTop: 0
    },
  },
  optionContainer: {
    display: "flex", width: "100%", alignItems: "center",
    [mobileScreen(theme)]: {
      width: "95%"
    },
  },
  BulletContainer: {
    display: "flex", minWidth: 50,
    [mobileScreen(theme)]: {
      minWidth: 30,
    },
  },
  bulletText: {
    padding: 10, background: "#003e4c", color: "#fff", fontSize: 28, height: 30, width: "100%", fontWeight: 600, borderRadius: "50%",
    [mobileScreen(theme)]: {
      fontSize: 16, height: 20, padding: '4px 6px',
      marginTop: 0,
      marginBottom: 0
    },
  },
  subTitleText: {
    paddingLeft: 20, textAlign: "left", color: "#043e4b", fontSize: 18, fontWeight: 500,
    [mobileScreen(theme)]: {
      fontSize: 12,
      marginTop: 8,
      marginBottom: 8,
      paddingTop: 0,
      paddingLeft: 10,
    },
  },
  button: {
    alignSelf: "center", padding: "10px 25px", color: "#fff", marginTop: 22, fontSize: 30, width: "38%", fontWeight: 600, backgroundColor: "#00b1d9", border: "none", float: "left", cursor: "pointer", fontFamily: "Oswald",
    [mobileScreen(theme)]: {
      padding: "5px 15px",
      marginTop: 20, fontSize: 20, width: "38%",
    },
  },
  step6Container: {
    display: "flex", flexDirection: "column", width: "75%", alignItems: "start", paddingLeft: "5%",
    [mobileScreen(theme)]: {
      paddingLeft: "2%",
      width: "90%",
    },
  },
  step6Options: {
    paddingTop: 20, textAlign: "left", color: "#043e4b", fontSize: 18, fontWeight: 500,
    [mobileScreen(theme)]: {
      fontSize: 12,
      paddingTop: 0,
      margin: "10px 0px"
    },
  },
  increamentButton: {
    fontSize:28, borderRadius: "50%", height: 35, width: 35, border: 0, backgroundColor: "#fff", cursor: "pointer",
    color: "#043e4b",
    [mobileScreen(theme)]: {
      border: 0,
      padding: 0,
      fontSize: 18,
      height: 25, width: 25
    },
  },
  increamentText: {
    padding: "0px 20px", fontSize: 28,
    fontWeight: 600, width: 70, margin: 0,
    [mobileScreen(theme)]: {
      fontSize: 18, width: 60,
    },
  },
  yesNoButtons:{
    fontSize: 24, padding: "10px 20px", borderRadius: "10%", border: 0, color: "#fff",
    [mobileScreen(theme)]: {
      fontSize: 12,
      padding: "5px 10px",
    },
  },
  amswerDescription6: {
    textAlign: "left", color: "#043e4b", fontSize: 16,
    [mobileScreen(theme)]: {
      fontSize: 10,
    },
  },
  subTilte7: {
    paddingTop: 20, textAlign: "left", color: "#043e4b", fontSize: 20, fontWeight: 500,
    [mobileScreen(theme)]: {
      paddingTop: 0,
      margin: 0,
      fontSize: 14,
    },
  },
  answerDescription: {
    padding: "20px 0px",
    fontSize: 18,
    color: "#043e4b",
    margin: 0,
    textAlign: "start",
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      fontSize: 14,
      padding: "5px 0px",
    },
  }
});
export default styles;
